module.exports = __webpack_public_path__ + "img/11ne.5fba8aeb.svg";